import { useState, useEffect } from 'react';
import './Settings.css';

const Settings = ({ isOpen, onClose, darkMode, onToggleDarkMode, mapStyle, onChangeMapStyle }) => {
  const handleToggleDarkMode = () => {
    const newDarkMode = !darkMode;
    onToggleDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode.toString());
  };

  const handleMapStyleChange = (style) => {
    onChangeMapStyle(style);
    localStorage.setItem('mapStyle', style);
  };

  if (!isOpen) return null;

  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-panel" onClick={(e) => e.stopPropagation()}>
        <div className="settings-header">
          <h3>Settings</h3>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="settings-content">
          <div className="settings-section">
            <h4>Appearance</h4>
            <p className="settings-description">
              Customize the visual appearance of the application
            </p>

            <div className="setting-item">
              <div className="setting-toggle-row">
                <div>
                  <span className="setting-label">Dark Mode</span>
                  <span className="setting-help">Use dark theme for reduced eye strain</span>
                </div>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={darkMode}
                    onChange={handleToggleDarkMode}
                    aria-label="Toggle dark mode"
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            </div>

            <div className="setting-item">
              <label htmlFor="mapStyle">
                <span className="setting-label">Map Style</span>
                <span className="setting-help">Choose the base map appearance</span>
              </label>
              <select
                id="mapStyle"
                value={mapStyle}
                onChange={(e) => handleMapStyleChange(e.target.value)}
                className="settings-select"
              >
                <option value="standard">Standard</option>
                <option value="minimal">Minimal</option>
                <option value="dark">Dark</option>
                <option value="satellite">Satellite</option>
                <option value="terrain">Terrain</option>
              </select>
            </div>
          </div>
        </div>

        <div className="settings-footer">
          <button className="btn-tertiary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;